import {
    useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import request from 'app/requests/Location.requests'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import Card from 'app/shared-components/Card'
import useLabel from 'app/hooks/useLabel'

import {
    Modification,
} from './LocationChangeSummary.types'
import getColumns from './locationChangeSummary.columns'
import useStyles from './LocationChangeSummary.style'

const OrderChangeSummary = ({
    id,
}: {
    id: number
}) => {
    const {
        classes,
    } = useStyles()
    const l = useLabel()

    const urlConfig = useMemo(() => {
        return request.modifications(id)
    }, [id])

    const load: (params: any) => Promise<{
        items: Modification,
        matches: number
    }> = useLoadDtoForSkyNetTable(urlConfig)

    const columns = useMemo(() => {
        return getColumns(l)
    }, [l])

    return (
        <Card
            title="Change History"
        >
            <RichTable
                configName="LocationChangeSummaryTable"
                name={urlConfig.name}
                load={load}
                columns={columns}
                uniqField="id"
                className={classes.tableContent}
                classNames={{
                    contentWrapper: classes.tableContentWrapper,
                }}
            />
        </Card>
    )
}

export default OrderChangeSummary
